import { Link } from "react-router-dom";
import { useFormikContext } from "formik";
// @ts-expect-error pure js
import TextInput from "../../UI/TextInput";
// @ts-expect-error pure js
import Radio from "../../UI/Radio";
import Tooltip from "../../UI/Tooltip";
import Text from "../../UI/Text";
import Callout from "../../UI/Callout";
import { IconInfoCircle } from "@tabler/icons-react";
// @ts-expect-error pure js
import ZoneTendue from "./ZoneTendue";
import ZoneTendueCallout from "./ZoneTendueCallout";
import styles from "./FinanceEssentials.module.css";

interface FinanceEssentialsValues {
  type?: string;
  zone_tendue?: string;
  loyer_reference?: string;
  nb_rooms?: string | number;
}

/**
 * Champs financiers minimaux affichés à la création du bien (l'onglet
 * « Finance et fiscalité » n'existe plus à la création) : nécessaires au bien
 * public/candidatures avant le premier bail. Le reste se saisit à la création
 * du locataire et est synchronisé vers le bien par le backend.
 */
export default function FinanceEssentials() {
  const { values } = useFormikContext<FinanceEssentialsValues>();

  const nbRooms = parseInt(String(values.nb_rooms)) || 0;

  return (
    <div className={styles.fields}>
      {nbRooms > 0 && (
        <Callout variant="info">
          Colocation à baux individuels : le loyer, les charges et le dépôt de
          garantie saisis ici s'appliqueront à chacune des {nbRooms} chambres.
          Vous pourrez ensuite les personnaliser chambre par chambre.
        </Callout>
      )}
      <div className={styles.inputs}>
        <TextInput
          type="number"
          name="loyer_hc"
          placeholder="380,10"
          step={"0.01"}
          label={`Loyer hors charge ${
            values.zone_tendue === "true" ? " (hors complément de loyer)" : ""
          }`}
          unit={"€"}
          mandatory
          marginForm=""
        />
        <TextInput
          type="number"
          name="charges"
          placeholder="50"
          step={"0.01"}
          unit={"€"}
          label="Montant des charges"
          mandatory
          marginForm=""
        />
        <TextInput
          type="number"
          name="deposit"
          placeholder="350"
          step={"0.01"}
          unit={"€"}
          label="Montant du dépôt de garantie"
          mandatory
          marginForm=""
        />
      </div>
      {values.type === "habitation" && (
        <div className={styles.question}>
          <Text>
            Votre logement est il situé en zone tendue ?{" "}
            <Tooltip
              content={
                <Text>
                  Rendez-vous sur le{" "}
                  <Link
                    to={
                      "https://www.service-public.fr/simulateur/calcul/zones-tendues"
                    }
                    target={"_blank"}
                  >
                    simulateur du gouvernement
                  </Link>{" "}
                  pour savoir si votre bien est situé en zone tendue
                </Text>
              }
            >
              <IconInfoCircle size={16} />
            </Tooltip>
          </Text>
          <div className={styles.radios}>
            <Radio name="zone_tendue" value="true" label="Zone tendue" />
            <Radio name="zone_tendue" value="false" label="Zone non tendue" />
          </div>
          <ZoneTendueCallout />
        </div>
      )}
      {(values.type === "commercial" || values.type === "garage") && (
        <div className={styles.question}>
          <Text>Indice d'indexation du loyer : </Text>
          <div className={styles.radiosCompact}>
            {values.type === "garage" && (
              <Radio name="type_indice" value="IRL" label="IRL" />
            )}
            <Radio name="type_indice" value="ILC" label="ILC" />
            <Radio name="type_indice" value="ILAT" label="ILAT" />
            <Radio name="type_indice" value="ICC" label="ICC" />
            {values.type === "commercial" && (
              <Radio name="type_indice" value="Aucun" label="Aucun" />
            )}
          </div>
        </div>
      )}
      {values.zone_tendue === "true" && (
        <ZoneTendue loyerReference={values.loyer_reference === "true"} />
      )}
    </div>
  );
}
